import React, { useRef, useState } from 'react';
import { useClickAway } from 'react-use';
import cc from 'classcat';
import { useFormikContext } from 'formik';
import styles from './sortpopup.module.sass';
import { Icon } from '../Icon';
import { IconSVG } from '../SpriteSVG';

export const SortPopup = ({ id, url, sorts, active, actionOnChange }) => {
  const { setFieldValue } = useFormikContext();
  const [isOpen, setIsOpen] = useState(false);
  const activeIndex = sorts.findIndex(
    i => active.sort_mode === i.mode && active.sort_direction === i.type,
  );
  const ref = useRef();

  useClickAway(ref, () => {
    if (isOpen) setIsOpen(false);
  });

  const onChoose = choice => {
    actionOnChange?.();
    setFieldValue(id, choice);
    setIsOpen(false);
  };

  return (
    <div className={styles.wrapper} ref={ref}>
      <button
        className={url === 'black_friday' ? styles.btnBf : styles.btn}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{sorts[activeIndex]?.title}</span>
        <div>
          <Icon
            icon={
              <IconSVG
                name={
                  url === 'black_friday'
                    ? 'common/sort-arrowsBf'
                    : 'common/sort-arrows'
                }
                width={16}
                height={16}
              />
            }
          />
        </div>
      </button>
      {isOpen && (
        <ul className={url === 'black_friday' ? styles.listBf : styles.list}>
          {sorts &&
            sorts.length &&
            sorts.map(({ title, mode, type }, index) => (
              <li key={title}>
                <button
                  type="button"
                  className={cc({
                    [url === 'black_friday' ? styles.activeBf : styles.active]:
                      index === activeIndex,
                  })}
                  onClick={() =>
                    onChoose({
                      sort_mode: mode,
                      sort_direction: type,
                    })
                  }
                >
                  {title}
                </button>
              </li>
            ))}
        </ul>
      )}
    </div>
  );
};

SortPopup.defaultProps = {
  sorts: [],
};
